
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"13","fill":"#263238","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.042 2.075L10.926.958 6.5 5.384 2.075.958.958 2.075 5.384 6.5.958 10.925l1.117 1.117L6.5 7.616l4.426 4.426 1.116-1.117L7.616 6.5l4.426-4.426z"}})])
          )
        }
      }
    